import { AppState } from '../reducers'
import { USER_STATE_KEY } from './constants'

export const getUser = (state: AppState) => state[USER_STATE_KEY]
export const getCurrentUser = (state: AppState) => getUser(state)
